import React, { Component } from 'react';
import _ from 'lodash';
class QuoteText extends Component {

  constructor(props) {
    super(props);
    this.state = {
      elementIndex: this.props.elementIndex
    }
  }

  render() {

    let section = {
      width: this.props.screenWidth / this.props.xScreens,
      height: this.props.screenHeight / this.props.yScreens
    };

    let margins = {
      left: section.width * 0.09,
      right: section.width * 0.09,
    };

    let cssStyle = {
      position: 'absolute',
      top: 0,
      width: this.props.screenWidth / this.props.sections,
      height: '100%',
      backgroundColor: this.props.bodyCopy.quoteBackdrop,
    }

    let spanStyle = {
      position: 'relative',
      width: '100%',
      height: '100%',
    }

    let spanSignature = {
      fontSize: this.props.screenHeight * 0.03125,
      fontWeight: 'bold',
      lineHeight: '150%',
    }

    spanSignature.fontSize = this.props.bodyCopy.signatureStyle.fontSize > 0 ? this.props.bodyCopy.signatureStyle.fontSize * this.props.screenHeight / 100 : this.props.screenHeight * 0.03125;
    spanSignature.fontStyle = _.get(this.props, 'bodyCopy.signatureStyle.fontStyle', 'normal');
    spanSignature.justification = _.get(this.props, 'bodyCopy.signatureStyle.justification', 'left');
    spanSignature.font = _.get(this.props, 'bodyCopy.signatureStyle.font', 'Roboto');
    spanSignature.fontWeight = _.get(this.props, 'bodyCopy.signatureStyle.fontWeight', 'bold');
    spanSignature.lineHeight = `${_.get(this.props, 'bodyCopy.signatureStyle.justification', '150')}%`;
    spanSignature.display = this.props.bodyCopy.signatureStyle.visible ? "block" : "none";
    spanSignature.color = _.get(this.props.bodyCopy.signatureStyle, 'fontColor', "#000000");

    let spanBodyTextStyle = {
      position: 'absolute',
      textAlign: 'justify',
      fontSize: this.props.screenHeight * 0.025,
      lineHeight: '185%'
    }

    spanBodyTextStyle.fontSize = this.props.bodyCopy.longQuoteStyle.fontSize > 0 ? this.props.bodyCopy.longQuoteStyle.fontSize * this.props.screenHeight / 100 : this.props.screenHeight * 0.025;
    spanBodyTextStyle.fontStyle = _.get(this.props, 'bodyCopy.longQuoteStyle.fontStyle', 'normal');
    spanBodyTextStyle.justification = _.get(this.props, 'bodyCopy.longQuoteStyle.justification', 'left');
    spanBodyTextStyle.font = _.get(this.props, 'bodyCopy.longQuoteStyle.font', 'Roboto');
    spanBodyTextStyle.fontWeight = _.get(this.props, 'bodyCopy.longQuoteStyle.fontWeight', 'bold');
    spanBodyTextStyle.lineHeight = `${_.get(this.props, 'bodyCopy.longQuoteStyle.lineHeight', '185')}%`;
    spanBodyTextStyle.display = this.props.bodyCopy.longQuoteStyle.visible ? "block" : "none";
    spanBodyTextStyle.color = _.get(this.props.bodyCopy.longQuoteStyle, 'fontColor', "#000000");
    
    let longQuoteCenterOffset = (Number(this.props.bodyCopy.longQuoteCenterOffset) + 50) + "%";
    let leftBodyCopy = 0;

    switch (this.props.bodyCopy.section) {
      case "left":
        leftBodyCopy = 0;
        break;
      case "middle":
        leftBodyCopy = this.props.screenWidth / 3;
        break;
      case "right":
        leftBodyCopy = (this.props.screenWidth / 3) * 2;
        break;
      default:
        break;
    } 

    return (
      <div style={{ ...cssStyle, left: leftBodyCopy }}>
        <div style={spanStyle}>
          <div style={{ ...spanBodyTextStyle, bottom: longQuoteCenterOffset, marginLeft: margins.left, marginRight: margins.right }}>
          <div className="ql-editor" dangerouslySetInnerHTML={{ __html: this.props.upperText }}></div>
            {
              this.props.lowerText.length === 0 ?
                <div>
                  <div style={{ display: 'inline-block', width: '100%', height: this.props.screenHeight * 0.06 }} />
                  <div style={{ ...spanSignature }}>
                    <div className="ql-editor" dangerouslySetInnerHTML={{ __html: this.props.signature }}></div>
                  </div>
                </div>
                : null
            }
          </div>
          {
            this.props.lowerText.length > 0 ?
              <div style={{ ...spanBodyTextStyle, top: longQuoteCenterOffset, marginLeft: margins.left, marginRight: margins.right }}>
                <div className="ql-editor" dangerouslySetInnerHTML={{ __html: this.props.lowerText }}></div>
                <div style={{ display: 'inline-block', width: '100%', height: this.props.screenHeight * 0.06 }} />
                <div style={{ ...spanSignature }}>
                  <div className="ql-editor" dangerouslySetInnerHTML={{ __html: this.props.signature }}></div>
                </div>
              </div>
              : null
          }
        </div>
      </div>
    );
  }
}

export default QuoteText


// WEBPACK FOOTER //
// ./src/Components/Quote/QuoteText.js